import { render } from "./FormUneditableText.vue?vue&type=template&id=396ee436&scoped=true"
const script = {}

import "./FormUneditableText.vue?vue&type=style&index=0&id=396ee436&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-396ee436"]])

export default __exports__